/* ============================================================
   STICKY BUY NOW BAR — logic
   --------------------------------
   Behavior:
   1. Watch the ORIGINAL buy-now section (#sticky-buy-bar-target)
   2. When it leaves the viewport: slide the sticky bar UP
   3. When it re-enters the viewport: slide the sticky bar DOWN
   4. Clicking the sticky BUY NOW button scrolls to the
      ORIGINAL add-to-cart button and triggers it
      -> Uses the EXISTING ProductForm web component
      -> No duplicate forms, no duplicate checkouts
      -> Variant / quantity / gift-wrap logic is untouched
   ============================================================ */

(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', initStickyBuyBar);

  function initStickyBuyBar() {
    var bar = document.getElementById('sticky-buy-bar');
    var target = document.getElementById('sticky-buy-bar-target');
    var button = document.getElementById('sticky-buy-bar-button');

    if (!bar || !target || !button) {
      return;
    }

    /* ----- Compute Ships-by date (e.g. "Ships by Thu, Jul 30th") ----- */
    var shipEl = document.getElementById('sticky-buy-bar-ship-date');
    if (shipEl && !shipEl.textContent) {
      shipEl.textContent = formatShipsByDate(addDays(new Date(), 2));
    }

    /* ----- IntersectionObserver: show / hide the bar ----- */
    if (!('IntersectionObserver' in window)) {
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            bar.classList.remove('is-visible');
          } else {
            bar.classList.add('is-visible');
          }
        });
      },
      {
        threshold: 0,
        rootMargin: '0px 0px 0px 0px'
      }
    );

    observer.observe(target);

    /* ----- Click handler: scroll to + trigger original button ----- */
    button.addEventListener('click', function (event) {
      event.preventDefault();

      var originalButton = findOriginalBuyButton();
      if (!originalButton) {
        return;
      }

      smoothScrollTo(target);

      window.setTimeout(function () {
        originalButton.focus({ preventScroll: true });

        window.requestAnimationFrame(function () {
          originalButton.click();
        });
      }, 450);
    });

    /* ----- Recompute observer on resize ----- */
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        observer.disconnect();
        observer.observe(target);
      }, 200);
    });
  }

  /* ============================================================
     HELPERS
     ============================================================ */

  function findOriginalBuyButton() {
    var target = document.getElementById('sticky-buy-bar-target');
    if (!target) return null;

    var btn = target.querySelector('button[name="add"]');
    if (btn) return btn;

    var dynamicBtn = target.querySelector('.shopify-payment-button__button');
    if (dynamicBtn) return dynamicBtn;

    return null;
  }

  function smoothScrollTo(element) {
    var headerHeight = 0;
    var stickyHeader = document.querySelector('.header-section:has(.header-is-sticky)');
    if (stickyHeader) {
      headerHeight = stickyHeader.offsetHeight || 0;
    }

    var rect = element.getBoundingClientRect();
    var targetY = window.pageYOffset + rect.top - headerHeight - 16;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      window.scrollTo(0, targetY);
    } else if ('scrollBehavior' in document.documentElement.style) {
      window.scrollTo({ top: targetY, behavior: 'smooth' });
    } else {
      window.scrollTo(0, targetY);
    }
  }

  function addDays(date, days) {
    var d = new Date(date.getTime());
    d.setDate(d.getDate() + days);
    return d;
  }

  function formatShipsByDate(date) {
    var days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return 'Ships by ' +
      days[date.getDay()] + ', ' +
      months[date.getMonth()] + ' ' +
      ordinal(date.getDate());
  }

  function ordinal(n) {
    var s = ['th', 'st', 'nd', 'th', 'th', 'th', 'th', 'th', 'th', 'th'];
    if (n < 11 || n > 13) {
      return n + (s[n % 10] || 'th');
    }
    return n + 'th';
  }
})();
